/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MortalityResponse } from '../../models/mortality-response';

export interface GetMortality$Params {
  harvestId: number;
  groupIdx?: Array<number>;
}

export function getMortality(http: HttpClient, rootUrl: string, params: GetMortality$Params, context?: HttpContext): Observable<StrictHttpResponse<MortalityResponse>> {
  const rb = new RequestBuilder(rootUrl, getMortality.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MortalityResponse>;
    })
  );
}

getMortality.PATH = '/api/harvests/{harvestId}/mortality';
